import { useParams } from 'react-router-dom';
import { toNumber } from 'lodash';

export const useBoloIdFromNavigation = () => {
    const params = useParams();

    const boloId = params.boloId ? toNumber(params.boloId) : undefined;

    return { boloId };
};
